import Mention from "@tiptap/extension-mention";
import { mergeAttributes } from "@tiptap/core";
import { createCollaboratePlaybookSuggestion } from "./createCollaboratePlaybookSuggestion";
import type { CollaborateUser } from "../types/collaborate";

export function createPlaybookMentionExtension(getUsers: () => CollaborateUser[]) {
  return Mention.extend({
    name: "playbook",

    renderHTML({ node, HTMLAttributes }) {
      const assignee = `@${node.attrs.label ?? node.attrs.id}`;
      return [
        "span",
        { class: "collaborate-playbook-inline", "data-playbook-inline": "true" },
        [
          "span",
          { class: "collaborate-playbook-chip" },
          ["span", { class: "collaborate-playbook-chip__tag" }, "Update playbook"],
          [
            "span",
            mergeAttributes(HTMLAttributes, { class: "collaborate-playbook-chip__assignee" }),
            assignee,
          ],
        ],
      ];
    },
  }).configure({
    HTMLAttributes: { class: "collaborate-playbook-mention" },
    renderLabel: ({ node }) => `@${node.attrs.label ?? node.attrs.id}`,
    suggestion: createCollaboratePlaybookSuggestion(getUsers),
    deleteTriggerWithBackspace: true,
  });
}
